import { gql } from '@apollo/client'
import { projectRemarksActivityFragment, projectTasksFragment } from './graphql'
import type { UseActionResult, UseMutationProps } from '@ztechapps/common.hook'
import { useActionMutation } from '@ztechapps/common.hook'
import type { SortProjectTasksArgs, Project } from '@ztechapps/common.contract'

export const sortProjectTasksQuery = gql`
  mutation sortProjectTasks($input: SortProjectTasksArgs!) {
    sortProjectTasks(input: $input) {
      _id
      tasks {
        ...projectTasksFragment
      }
    }
  }
  ${projectTasksFragment}
  ${projectRemarksActivityFragment}
`

export const useSortProjectTasks = (
  { query, ...props } = {} as UseMutationProps
): UseActionResult<Project, SortProjectTasksArgs> => {
  query = query ?? sortProjectTasksQuery

  return useActionMutation({
    query,
    ...props,
  })
}
